import type { Cluster } from '../types'
import { imageUrl } from '../api'
import { isInProgress } from '../activity'
import { relTime } from '../relTime'

// LatestIncident is the watched camera's most recent incident under live view,
// with the way into it (#280): a dispatcher watching a camera is usually
// watching because of one.
export function LatestIncident({ cluster, onOpen }: { cluster: Cluster; onOpen: () => void }) {
  const label = cluster.label === 'tamper' ? 'View lost' : (cluster.label || 'Detection').replace(/_/g, ' ')
  const going = isInProgress(cluster)
  return (
    <section aria-label="Latest on this camera" className="flex flex-wrap items-center gap-3.5 px-3.5 py-3 rounded-lg border border-zinc-800 bg-zinc-900">
      <img
        src={imageUrl(cluster.primary_event_id ?? cluster.last_event_id, cluster.end_time)}
        alt=""
        width={72}
        height={40}
        loading="lazy"
        className="w-[72px] h-10 rounded-md object-cover bg-zinc-950"
      />
      <div className="min-w-0 flex flex-col gap-0.5">
        <span className="text-xs font-mono uppercase tracking-wider text-zinc-400">Latest on this camera</span>
        <span className="text-sm text-zinc-100">
          <strong className="font-semibold capitalize">{label}</strong>
          <span className="text-zinc-400">
            {` · ${cluster.event_count} ${cluster.event_count === 1 ? 'detection' : 'detections'} · `}
            {going ? <span className="text-live">in progress</span> : relTime(cluster.end_time)}
          </span>
        </span>
      </div>
      <div className="flex-1" />
      <button type="button" onClick={onOpen} className="h-9 px-3.5 rounded-md border border-zinc-800 bg-zinc-950 text-sm font-semibold text-zinc-100 hover:bg-zinc-800">
        Open incident
      </button>
    </section>
  )
}
